/*
 * Public API Surface of ngx-gravatar
 */

export { GravatarModule } from './lib/gravatar.module';
export { GravatarConfig } from './lib/gravatar-config';
export { NgxGravatarService } from './lib/ngx-gravatar.service';
export { NgxGravatarDirective } from './lib/ngx-gravatar.directive';
export { FALLBACK, RATING } from './lib/ngx-gravatar.enums';
